import { TipoConsultaEnum } from '../service-proxies/service-proxies';

export class TipoConsultaItem {
    constructor(public name: string, public type: TipoConsultaEnum) { }
}

export class TipoConsultaList {
    tipoConsulta: TipoConsultaItem[] = [
        new TipoConsultaItem('Presencial', TipoConsultaEnum._0),
        new TipoConsultaItem('Teleconsulta', TipoConsultaEnum._1),
    ];

    getNome(tipoConsulta: TipoConsultaEnum): string {
        const item = this.tipoConsulta.find(x => x.type === tipoConsulta);
        return item ? item.name : 'Nome não encontrado';
    }
}